"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SliderComponent =
/*#__PURE__*/
function () {
  function SliderComponent() {
    _classCallCheck(this, SliderComponent);

    this._slider = $(".slider");
    this.init();

    if ($(".cocoen").length >= 1) {
      new Cocoen(document.querySelector('.cocoen'));
    }
  }

  _createClass(SliderComponent, [{
    key: "init",
    value: function init() {
      this._slider.bxSlider({
        auto: true,
        touchEnabled: true,
        useCSS: false,
        nextText: $("#arrowRight").html(),
        prevText: $("#arrowLeft").html()
      });
    }
  }]);

  return SliderComponent;
}();